import request from "@/utils/request";

export default function agengUnBindQrCode(deviceId, socketNum) {
    return request({
        url: `/device/qrcode/agentUnBindQrCode/${deviceId}/${socketNum}`,
        method: 'post',
    })
}
